<footer
  *ngIf="showFooter()"
  class="bg-primary_text flex flex-col md:flex-row justify-center items-center w-full h-20 md:h-14 mt-auto">
  <nav class="flex flex-col justify-center text-white text-xs md:text-sm text-center font-bold">
    <div class="flex gap-4 md:gap-8">
      <div class="hidden lg:block">
        {{ "footer.year" | translate }}
      </div>
      <div class="underline">
        <a
          [routerLink]="MENTIONS_LEGALES"
          target="_blank"
          >{{ "footer.legal" | translate }}</a
        >
      </div>
      <div class="underline">
        <a
          [routerLink]="CONDITIONS_GENERALES"
          target="_blank">
          {{ "footer.generalConditions" | translate }}
        </a>
      </div>
      <div class="underline">
        <a
          [href]="VYV_GESTION_DONNEES"
          target="_blank">
          {{ "footer.dataProtection" | translate }}
        </a>
      </div>
    </div>
    <div class="block lg:hidden text-center mt-2">
      {{ "footer.year" | translate }}
    </div>
  </nav>
</footer>
